import React from "react";
import { useHistory } from "react-router-dom";

export default function useRedirect() {
  const history = useHistory();
  return history.push;
}
